<template>
  <div class="tools-documents-page">
    <div v-if="paramError" class="tools-documents-param-error-wrap">
      <p class="tools-documents-param-error">{{ paramError }}</p>
    </div>

    <AppMask
      v-else-if="needsLogin && !isReady"
      title="在线文档"
      icon-right="md-document"
      :loading="true"
    >
      <div class="tools-documents-login-hint">系统登录中，请稍后…</div>
    </AppMask>

    <DocumentsEditor
      v-else-if="directoryId && canEditMode"
      :embed-dir-id="directoryId"
      :hide-bar-close="hideBarClose"
      tools-layout
      @go-preview="goPreview"
    />
    <DocumentsView
      v-else-if="directoryId"
      :embed-dir-id="directoryId"
      :use-public-api="isPublicAccess"
      :hide-edit="hideEdit"
      :hide-bar-close="hideBarClose"
      tools-layout
      @go-editor="goEditor"
    />
  </div>
</template>

<script>
import AppMask from '@/components/app/mask-loading';
import DocumentsView from '@/pages/core/documents/view.vue';
import DocumentsEditor from '@/pages/core/documents/editor.vue';

export default {
  name: 'ToolsDocuments',
  components: {
    AppMask,
    DocumentsView,
    DocumentsEditor,
  },
  data() {
    return {
      isReady: false,
      uid: null,
    };
  },
  computed: {
    directoryId() {
      const dir = this.$route.query.dir;
      return dir != null && String(dir).trim() !== '' ? String(dir).trim() : '';
    },
    needsLogin() {
      return !!this.$route.query.uid;
    },
    isPublicAccess() {
      return !this.needsLogin;
    },
    isPreview() {
      const p = this.$route.query.preview;
      return p === '1' || p === 1 || p === true || p === 'true';
    },
    canEditMode() {
      return this.needsLogin && !this.isPreview;
    },
    hideEdit() {
      return this.isPreview || this.isPublicAccess;
    },
    hideBarClose() {
        return true
    },
    paramError() {
      if (!this.directoryId) {
        return '缺少参数 dir（知识库目录 id），无法访问';
      }
      return '';
    },
  },
  watch: {
    '$route.query.uid': {
      handler(uid) {
        if (uid) {
          this.uid = uid;
          this.login(uid);
        } else {
          this.isReady = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    login(uid) {
      this.isReady = false;
      this.$store.dispatch('session/login_zzl', {uid})
        .catch(() => {
          this.$Message.error('登录失败');
        })
        .finally(() => {
          this.isReady = true;
        });
    },
    goPreview(selectedDocId) {
      const query = {...this.$route.query, preview: '1'};
      if (selectedDocId) {
        query.doc = selectedDocId;
      }
      this.$router.replace({path: this.$route.path, query}).catch(() => {});
    },
    goEditor() {
      const query = {...this.$route.query};
      delete query.preview;
      this.$router.replace({path: this.$route.path, query}).catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.tools-documents-page {
  height: 100%;
  min-height: 100%;
  min-height: 100dvh;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}

.tools-documents-param-error-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 240px;
}

.tools-documents-param-error {
  font-size: 14px;
  color: var(--subtext2);
}

.tools-documents-login-hint {
  font-size: 14px;
  color: var(--subtext2);
  margin-top: 12px;
}
</style>
